/** @jsxImportSource @emotion/react */
import { TableCell, TableBody, TableRow, Icon } from '@coreai/component-library';
import { THeaderProps } from './THeader';
import { css, useTheme } from '@emotion/react';
import React, { useState } from 'react';
import ESGFlaggingPanel from './RiskFlagingWords';
interface AccordionTBodyProps {
    columns: THeaderProps[];
    tableData: any[];
    handleRowClick: (rowData: any, event: React.MouseEvent) => void;
    tableRowClass: string;
}


export default function AccordionTBody({columns, tableData, handleRowClick, tableRowClass}: AccordionTBodyProps) {
    const theme = useTheme();
    const [openRow, setOpenRow] = useState<number | null>(null);

  const tableRowStyle = () => css`
    cursor: pointer;
    &:hover {
      background-color: ${theme.colors.background};
    }
  `;

  const handleToggleRow = (index: number) => {
    setOpenRow((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <TableBody>
        {
            tableData.map((rowData: any, index: number) => {
                return (
                    <React.Fragment key={rowData.id || index}>
                        <TableRow
                            key={rowData.id || index}
                            onClick={() => handleToggleRow(index)}
                            css={tableRowStyle()}
                            className={tableRowClass || ''}
                        >
                            {columns.map((column: THeaderProps) => {
                                if (!column?.isHidden) {
                                    if( column?.key === 'actions'){
                                        return (
                                            <TableCell className={column?.tdCellClassName || ''}>
                                                {openRow === index ? <Icon name="chevron-up" size="xs" /> : <Icon name="chevron-down" size="xs" />}
                                            </TableCell>
                                        );
                                    }
                                    if (typeof column?.renderRowContent === 'function') {
                                        return (
                                            <TableCell className={column?.tdCellClassName || ''}>
                                                {column?.renderRowContent(rowData)}
                                            </TableCell>
                                        );                                    
                                    }
                                    return (
                                        <TableCell className={column?.tdCellClassName || ''}>
                                            {rowData[column?.key]}
                                        </TableCell>
                                    );
                                }
                            })}
                        </TableRow>
                        {openRow === index && (
                        <TableRow>
                            <TableCell colSpan={columns.length} style={{ padding: 0 }}>
                            <ESGFlaggingPanel rowDataList={{...rowData, occurrences : rowData?.occurences ?? rowData?.occurrences, index: rowData?.index ?? index }}/>
                            </TableCell>
                        </TableRow>
                        )}
                    </React.Fragment>
                );
            })
        }
    </TableBody>
  )
};